var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button full-100 is-primary",on:{"click":function($event){return _vm.handlePlayOnWeb()}}},[_vm._v(" "+_vm._s(_vm.$t('playGameBtn'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }